/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsonlybusinessbadge3Inputs */

const en_groupsonlybusinessbadge3 = /** @type {(inputs: Groupsonlybusinessbadge3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only you write`)
};

const de_groupsonlybusinessbadge3 = /** @type {(inputs: Groupsonlybusinessbadge3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur du schreibst`)
};

/**
* | output |
* | --- |
* | "Only you write" |
*
* @param {Groupsonlybusinessbadge3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsonlybusinessbadge3 = /** @type {((inputs?: Groupsonlybusinessbadge3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsonlybusinessbadge3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsonlybusinessbadge3(inputs)
	return de_groupsonlybusinessbadge3(inputs)
});
export { groupsonlybusinessbadge3 as "groupsOnlyBusinessBadge" }